import { v4 as uuidv4 } from 'uuid';
import { RecordTag, USER_DOCUMENT_LINK_TAG, USER_NOTE_TAG } from '@/constants/documentTags.ts';
import { DocumentWithDownloadUrl as Document } from '@/client';
import { displayRecordName } from '@/utils/documentUtils.ts';

/** Reconstructs a Document object from a Task */
/**
 * Generates a display name for a document based on its first tag and text content
 */
export function getDisplayName(firstTag: string, text: string, tags: RecordTag[]) {
	const fallbackName =
		firstTag === USER_NOTE_TAG ? 'Note' : firstTag === USER_DOCUMENT_LINK_TAG ? 'Link' : 'Document';
	// @ts-ignore
	const document: Document = {
		filename: fallbackName,
		description: text,
		// @ts-expect-error - tags type mismatch
		tags: tags.map((tag) => ({ name: tag })),
	};

	return displayRecordName(document);
}

/**
 * Generates a temporary task ID for upload tracking
 * Uses UUID to prevent collisions that can occur with Date.now() in rapid succession
 */
export function generateUiTaskId(input: File | string): string {
	const suffix = input instanceof File ? input.name : input;

	return `${uuidv4()}-${suffix}`;
}

/**
 * Creates metadata for an upload task
 */
export function createTaskMetadata(houseId: number, fileSize: number, displayName: string, tags?: RecordTag[] | null) {
	return {
		filename: displayName,
		fileSize,
		houseId,
		tags: tags || null,
	};
}
